import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body no-padding" }
const _hoisted_8 = { class: "settings-list" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "settings-list-item-caption" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "settings-list-item-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-container modal-container-corner no-transition", { hidden: !_ctx.display }]),
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": !_ctx.display,
    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
    onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.escapeToClose && _ctx.escapeToClose(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-md",
      role: "document",
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.stopPropagationEvent && _ctx.stopPropagationEvent(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Select a theme")), 1),
        _createElementVNode("button", {
          type: "button",
          class: "modal-close-btn",
          title: _ctx.$t('Close'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTheme('light')))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["settings-list-item-icon", { 'check-invisible': _ctx.theme !== 'light' }])
            }, _hoisted_10, 2),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("Light")), 1)
          ], 32),
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeTheme('dark')))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["settings-list-item-icon", { 'check-invisible': _ctx.theme !== 'dark' }])
            }, _hoisted_13, 2),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("Dark")), 1)
          ], 32)
        ])
      ])
    ])
  ], 42, _hoisted_1))
}